export const DEFAULT_LANGUAGE = 'fr'
export const FALLBACK_LANGUAGE = 'fr'
export const SUPPORTED_LANGUAGES = ['fr']